<template>
  <div class="rounded-lg border border-border bg-gray-50 px-4 py-4 flex items-center justify-between gap-4">
    <div class="flex items-center gap-3 min-w-0">
      <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white border border-border">
        <Briefcase class="w-4 h-4 text-gray-500" />
      </div>
      <div class="min-w-0">
        <p class="text-sm font-medium text-gray-900">Free job support has ended</p>
        <p class="text-xs text-muted-foreground mt-0.5 leading-snug">Subscribe to a paid plan to continue receiving job search assistance.</p>
      </div>
    </div>
    <button
      @click="goToTuition"
      class="shrink-0 inline-flex items-center px-3 py-1.5 bg-cosmicPurple text-white text-xs font-medium rounded-md hover:bg-cosmicPurple/90 transition-colors"
    >
      Get Job Support
    </button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { Briefcase } from 'lucide-vue-next'
import { APP_ROUTES } from '@/const/appRoutes'

const router = useRouter()

const goToTuition = () => router.push(APP_ROUTES.TUITION)
</script>
